import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
// import Typography from "@material-ui/core/Typography";
// import NavLink from "./NavLink";
// import Hidden from "@material-ui/core/Hidden";
import { Link } from "@reach/router";
import { navContent } from "./config";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  tabLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

function NavTabs(props) {
  const { navLocation } = props;
  const classes = useStyles();
  const [value, setValue] = useState(navLocation);

  function handleChange(event, newValue) {
    setValue(newValue);
  }
  useEffect(() => {
    setValue(navLocation);
  }, [navLocation]);
  return (
    <Tabs
      variant="fullWidth"
      value={value}
      onChange={handleChange}
      className={classes.root}
    >
      {navContent.map(({ label, link }) => (
        <Tab
          label={label}
          key={label}
          value={link}
          component={Link}
          to={`/${link}`}
          className={classes.tabLink}
        />
      ))}
    </Tabs>
  );
}
export default NavTabs;
